var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTemplates(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.6001 0.879883H9.3999C9.3623 0.407227 9.08301 0.149414 8.56738 0.149414H3.42725C2.91699 0.149414 2.63232 0.407227 2.6001 0.879883ZM1.50439 2.43213H10.4956C10.4204 1.92188 10.1626 1.63184 9.59326 1.63184H2.40674C1.8374 1.63184 1.57959 1.92188 1.50439 2.43213ZM2.13818 12.0894H9.85645C10.9736 12.0894 11.5591 11.5093 11.5591 10.4028V4.99414C11.5591 3.8877 10.9736 3.30762 9.85645 3.30762H2.13818C1.01562 3.30762 0.435547 3.88232 0.435547 4.99414V10.4028C0.435547 11.5093 1.01562 12.0894 2.13818 12.0894Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTemplates);
export default __webpack_public_path__ + "static/media/icon-templates.57621fa8e8113997b0eb3e8d6fdd3b47.svg";
export { ForwardRef as ReactComponent };